import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { LanguageProvider } from './contexts/LanguageContext';
import { VideoProvider } from './contexts/VideoContext';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Services from './pages/Services';
import ScrollToTopButton from './components/ScrollToTopButton';
import theme from './theme';
import './index.css';
import './App.css';
import Footer from './components/Footer';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LanguageProvider>
        <VideoProvider>
          <Router>
            <div className="App" style={{ margin: 0, padding: 0 }}>
              <Navigation />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
              <Footer />
              <ScrollToTopButton />
            </div>
          </Router>
        </VideoProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
